export default __webpack_public_path__ + "static/media/Frame9.f04143fe.png";